import { render, staticRenderFns } from "./SpeakerInfoModal.vue?vue&type=template&id=47467cac&scoped=true&"
import script from "./SpeakerInfoModal.vue?vue&type=script&lang=js&"
export * from "./SpeakerInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./SpeakerInfoModal.vue?vue&type=style&index=0&id=47467cac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47467cac",
  null
  
)

export default component.exports